// extracted by mini-css-extract-plugin
export var bgColor = "bottomNav-module--bgColor--HHKSw";
export var linkText = "bottomNav-module--linkText--H1oa+";
export var footerText = "bottomNav-module--footerText--9aG-Z";
export var footerNav = "bottomNav-module--footerNav--HnGP-";
export var footerImg = "bottomNav-module--footerImg--6OvJM";
export var disclaimer = "bottomNav-module--disclaimer--6TIBo";